module.exports = __webpack_public_path__ + "static/media/branding-img11.f0eda683.jpg";